export default "__VITE_ASSET__BXG_qdMB__"